module.exports = __webpack_public_path__ + "img/jie_huanjing.f05f1468.jpg";